import { render, staticRenderFns } from "./TeachingPersonalCollect.vue?vue&type=template&id=c5b0b3f6&scoped=true"
import script from "./TeachingPersonalCollect.vue?vue&type=script&lang=js"
export * from "./TeachingPersonalCollect.vue?vue&type=script&lang=js"
import style0 from "./TeachingPersonalCollect.vue?vue&type=style&index=0&id=c5b0b3f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b0b3f6",
  null
  
)

export default component.exports